import { render, staticRenderFns } from "./LeaveTypeSettings.vue?vue&type=template&id=04d08b06&scoped=true&"
import script from "./LeaveTypeSettings.vue?vue&type=script&lang=js&"
export * from "./LeaveTypeSettings.vue?vue&type=script&lang=js&"
import style0 from "./LeaveTypeSettings.vue?vue&type=style&index=0&id=04d08b06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d08b06",
  null
  
)

export default component.exports